import { render, staticRenderFns } from "./merchant_eval_page.vue?vue&type=template&id=4efce50c&scoped=true"
import script from "./merchant_eval_page.vue?vue&type=script&lang=js"
export * from "./merchant_eval_page.vue?vue&type=script&lang=js"
import style0 from "./merchant_eval_page.vue?vue&type=style&index=0&id=4efce50c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efce50c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4efce50c')) {
      api.createRecord('4efce50c', component.options)
    } else {
      api.reload('4efce50c', component.options)
    }
    module.hot.accept("./merchant_eval_page.vue?vue&type=template&id=4efce50c&scoped=true", function () {
      api.rerender('4efce50c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/merchant/merchant_eval_page.vue"
export default component.exports